<div class="custom-label mdc-label">
  <mat-icon>blur_on</mat-icon>
  {{ props.label }} {{ props['required'] ? '*' : '' }}
</div>
<div
  class="file-input-container"
  [ngClass]="{
    'file-formly-error': formControl.invalid && formControl.touched,
    disabled: props.disabled,
  }"
>
  <input
    type="file"
    #fileInput
    hidden
    [disabled]="props.disabled ?? false"
    [formlyAttributes]="field"
    [accept]="props['accept']"
    [required]="props['required'] ?? false"
    (change)="onFileSelected($event)"
    [multiple]="props.multiple ?? false"
    [class.disabled]="_base64Files.length >= 1"
  />
  <div
    class="upload-button-formly-container"
    [ngClass]="{
      'file-formly-error': formControl.invalid && formControl.touched,
      disabled: props.disabled,
    }"
  >
    <mat-icon class="medium upload-icon">cloud_upload</mat-icon>
    @if (!props.disabled) {
      <button
        matButton="outlined"
        color="primary"
        type="button"
        (click)="openFilePicker()"
        [disabled]="props.disabled ?? false"
        class="upload-button-formly"
        [ngClass]="{
          'file-formly-error': formControl.invalid && formControl.touched,
        }"
      >
        <div class="place-older-upload">
          <mat-icon>upload</mat-icon>
          {{ 'buttons.add' | translate }}
        </div>
      </button>
    }
  </div>
  <!-- FILE DISPLAY or text -->
  @if (_base64Files.length > 0) {
    <div class="files-container">
      @for (file of _base64Files; track $index) {
        <div class="file-Container">
          <span>{{ file.fileName }}</span>
          @if (showDelete()) {
            <button type="button" (click)="deleteFile(file)" matIconButton>
              <mat-icon class="error-symbol">delete</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  }
</div>
<div class="file-formly-error-container">
  <div
    class="mat-mdc-form-field-subscript-wrapper mat-mdc-form-field-bottom-align"
  >
    @if (formControl.touched) {
      <div class="mat-mdc-form-field-error-wrapper">
        <mat-error>
          @if (formControl.hasError('required')) {
            <formly-validation-message
              [field]="field"
            ></formly-validation-message>
          }
          @if (formControl.hasError('fileSize')) {
            {{ 'labels.warnings.data-size-exceeded' | translate }}
          }
          @if (formControl.hasError('fileType')) {
            {{
              'labels.warnings.data-type-mismatch'
                | translate: { types: props.accept }
            }}
          }
          @if (formControl.hasError('maxCount')) {
            {{
              'labels.warnings.data-count-exceeded'
                | translate: { count: props.maxFiles }
            }}
          }
          @if (formControl.hasError('sizeIs0')) {
            {{ 'labels.warnings.data-size-0' | translate }}
          }
        </mat-error>
      </div>
    } @else {
      <div class="mat-mdc-form-field-hint-wrapper">
        @if (props.multiple) {
          <mat-hint>
            {{ _base64Files.length || 0 }} / {{ props.maxFiles }}
            {{ 'labels.files' | translate }}
          </mat-hint>
        }
        <mat-hint align="end">
          {{ 'labels.max-data' | translate }} {{ props.maxFileSizeMB ?? 5 }}
          {{ 'labels.mb' | translate }}
        </mat-hint>
      </div>
    }
  </div>
</div>
